import { Grid } from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../Common/DataTable';
import { HazardAnalysisData } from './utils/types';
import { RootState } from '../../redux/rootState';
import { setLoader } from '../../redux/loaderSlice';
import { exportToExcelData } from '../../Common/PageHeader/helper';
import { getHazardAnalysisData } from './redux/hazardAnalysisSlice';
import {
  resetPagination, setPageNumber, setPageSize, setSearchParam,
  setSortColumn, setSortDirection,
} from '../taiReportingSystem/redux/sliceReportWorkspace';

function ScreenHazardAnalysis() {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  // const [page, setPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [searchQuery, setSearchQuery] = useState('');
  const {
    pageNumber, pageSize, searchParam, sortColumn, sortDirection,
  } = useSelector((state: RootState) => state.reportWorkspaceReducer);
  const { historyStack } = useSelector((state:RootState) => state.masterDataReducer);
  const { hazardAnalysisListData, TotalRecords, isLoading } = useSelector((state: RootState) => state.hazardAnalysisReducer);

  const handleData = () => {
    const params = {
      page: pageNumber,
      rowsPerPage: pageSize,
      searchQuery: searchParam,
      sortCol: sortColumn,
      sortDir: sortDirection,
    };
    dispatch(getHazardAnalysisData(params));
  };

  useEffect(() => {
    handleData();
  }, [pageNumber, pageSize, searchParam, sortColumn, sortDirection]);

  const data: HazardAnalysisData[] = useMemo(() => {
    if (hazardAnalysisListData?.length > 0) {
      const transformedData = hazardAnalysisListData?.map((item, index) => ({
        sn: index,
        jobOrder: item?.JobOrder,
        action: 'edit',
        id: item?.JobOrder,
      }));
      return transformedData;
    }
    return [];
  }, [hazardAnalysisListData]);

  const excelData = useMemo(() => hazardAnalysisListData?.map((item) => {
    const transformedDataItem = {
      jobOrder: item?.JobOrder,
    };
    return transformedDataItem;
  }), [hazardAnalysisListData]);

  const columns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'jobOrder', label: 'Job Order' },
    ],
    [],
  );

  const handleEdit = (id: string) => {
    Navigate(`${id}`);
  };

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: excelData,
      },
      'HAZARD_ANALYSIS',
    );
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  useEffect(() => {
    if (historyStack) {
      const finderString = '/hazard-analysis/';
      const last = historyStack[historyStack.length - 1];
      const sLast = historyStack[historyStack.length - 2];
      if (!(
        last?.includes(finderString)
          || (sLast?.includes(finderString) && last === '/hazard-analysis')
      )) {
        dispatch(resetPagination());
      }
    }
  }, [historyStack]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="HAZARD ANALYSIS" downloadExcel={downloadExcel} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <DataTable<HazardAnalysisData>
          data={data}
          columns={columns}
          totalRecords={TotalRecords}
          page={pageNumber}
          setPage={(e) => { dispatch(setPageNumber(e)); }}
          rowsPerPage={pageSize}
          setRowsPerPage={(e) => { dispatch(setPageSize(e)); }}
          searchQuery={searchParam}
          setSearchQuery={(e) => { dispatch(setSearchParam(e)); dispatch(setPageNumber(1)); }}
          sortCol={sortColumn}
          setSortCol={(e) => { dispatch(setSortColumn(e)); dispatch(setPageNumber(1)); }}
          sortDir={sortDirection}
          setSortDir={(e) => { dispatch(setSortDirection(e)); dispatch(setPageNumber(1)); }}
          handleData={handleData}
          handleEdit={handleEdit}
          handleDataFromComponent
        />
      </Grid>
    </Grid>
  );
}

export default ScreenHazardAnalysis;
